import { useMemo, useRef } from 'react';
import { useLocation, useNavigation } from 'react-router';
import { isContentFolderListingPathname } from '@/lib/content-url';
import { isSamePathnameListingDataNavigationPending } from '@/lib/plp-panel-url-state';

export function useContentFolderListingNavigation() {
    const location = useLocation();
    const navigation = useNavigation();
    const listingTopRef = useRef<HTMLDivElement>(null);

    const isListingLoading = useMemo(() => {
        if (navigation.state === 'idle' || !navigation.location) {
            return false;
        }

        const pathnameChanged = navigation.location.pathname !== location.pathname;

        if (pathnameChanged) {
            return (
                isContentFolderListingPathname(location.pathname) &&
                isContentFolderListingPathname(navigation.location.pathname)
            );
        }

        return isSamePathnameListingDataNavigationPending({
            pathname: location.pathname,
            search: location.search,
            navigationState: navigation.state,
            navigationLocation: navigation.location,
        });
    }, [location.pathname, location.search, navigation.location, navigation.state]);

    return {
        listingTopRef,
        isListingLoading,
    };
}
